import BlogEditor from '@/components/blog/BlogEditor';
import { useBlogQueries } from '@/hooks/queries/useBlogQueries';
import { useAuthWithProfile } from '@/hooks/useAuth';
import { BlogPostForm } from '@/types/blog';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/blog/_admin/new')({
  component: BlogCreatePage,
})

function BlogCreatePage() {

  const navigate = useNavigate();
  const { profile } = useAuthWithProfile();

  const { createBlogPostMutation } = useBlogQueries();

  const handleSubmit = async (data: BlogPostForm) => {
    await createBlogPostMutation.mutate({ data, userId: profile.user_id });
    navigate({ to: '/blog' });
  };

  return (
    <div className="min-h-screen bg-background py-12">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Create New Post</h1>
        <BlogEditor
          onSubmit={handleSubmit}
          isSubmitting={createBlogPostMutation.isPending}
        />
      </div>
    </div>
  );
}